import {
  SpreadsheetDocumentsData,
  parseSpreadsheetDocuments,
} from '../models/SpreadsheetDocument';
import { API_ENDPOINTS } from '../config/api';
import { apiClient } from './api/apiClient';

/**
 * 현장 계정 정보 스프레드시트 API 클라이언트 (다중 문서).
 *
 * 백엔드는 projects.account_spreadsheet JSON 컬럼에 통째로 저장(opaque blob) —
 * IP/네트워크·자재와 같은 구조다. 계정 정보는 민감하므로 백엔드 GET 도
 * admin/editor 로 제한돼 있다(viewer 는 403).
 */

/**
 * 수정일이 자동 기입되는 컬럼 이름. 그리드가 컬럼을 이름으로 찾으므로
 * 아래 기본 컬럼 정의와 반드시 같은 문자열이어야 한다.
 */
export const ACCOUNT_UPDATED_COLUMN = '업데이트 날짜';

/** 계정 정보 기본 컬럼 — 신규 현장 첫 로드 / "빈 문서" seed 에 사용. */
export const DEFAULT_ACCOUNT_COLUMNS: ReadonlyArray<{ name: string; width: number }> = [
  { name: '구분', width: 140 },
  { name: '대상 / 장비', width: 180 },
  { name: '주소 / 접속 경로', width: 220 },
  { name: '아이디', width: 140 },
  { name: '비밀번호', width: 160 },
  { name: '용도', width: 180 },
  { name: '비고', width: 180 },
  { name: ACCOUNT_UPDATED_COLUMN, width: 140 },
];

const ACCOUNT_DOC_NAME = '계정 정보';

interface SpreadsheetApiResponse {
  success: boolean;
  message: string;
  data?: unknown;
}

export class AccountSpreadsheetService {
  static async get(projectId: number): Promise<SpreadsheetDocumentsData> {
    const response = await apiClient.get<SpreadsheetApiResponse>(
      API_ENDPOINTS.SITE_MANAGEMENT.ACCOUNT_SPREADSHEET.GET(projectId),
    );
    if (!response.data.success) {
      throw new Error(response.data.message || '계정 스프레드시트 조회 실패');
    }
    return parseSpreadsheetDocuments(response.data.data, {
      defaultDocName: ACCOUNT_DOC_NAME,
      defaultColumns: DEFAULT_ACCOUNT_COLUMNS,
    });
  }

  static async update(projectId: number, data: SpreadsheetDocumentsData): Promise<void> {
    const response = await apiClient.put<SpreadsheetApiResponse>(
      API_ENDPOINTS.SITE_MANAGEMENT.ACCOUNT_SPREADSHEET.UPDATE(projectId),
      data,
    );
    if (!response.data.success) {
      throw new Error(response.data.message || '계정 스프레드시트 저장 실패');
    }
  }
}
